import cn from 'classnames';
import React, { ComponentPropsWithoutRef } from 'react';
import { PolymorphicComponentProps } from 'apps/sigma2-ui/src/lib/types';
import { CardStyleProps } from 'apps/sigma2-ui/src/components/ui/CardStyle';

type CardProps<C extends React.ElementType> = PolymorphicComponentProps<C> &
  Omit<ComponentPropsWithoutRef<C>, keyof PolymorphicComponentProps<C>> &
  CardStyleProps;

export const Card = <C extends React.ElementType = 'div'>({
  children,
  className: customClasses,
  backgroundClassName,
  paddingClassName,
  shadowClassName,
  roundedClassName,
  as,
  ...rest
}: CardProps<C>) => {
  const className = cn(
    roundedClassName ?? 'rounded-lg',
    paddingClassName ?? 'p-6',
    backgroundClassName ?? 'bg-white',
    shadowClassName ?? 'shadow-2px',
    customClasses,
  );
  const Component = as ?? 'div';
  return (
    <Component className={className} {...rest}>
      {children}
    </Component>
  );
};
